import { useFormikContext } from 'formik';
import get from 'lodash/get';
import React from 'react';

import { DefaultItemProps, Select } from '@candu-ai/analytics/ui';
import { DefinitionDatePicker, TimeframeInput } from 'dashboard/pages/Segment/components/DefinitionFormFields';
import { SelectInputWrapper } from 'dashboard/pages/Segment/components/DefinitionFormFields/DefinitionFormComponents';
import { eventOccurredOptions } from 'dashboard/pages/Segment/components/constants';
import { DefinitionFormikValues } from 'dashboard/pages/Segment/components/types';

interface DateOperandProps {
  base: string;
  isAbsoluteDate?: boolean;
  readOnly?: boolean;
}

const DateOperand = ({ base, isAbsoluteDate, readOnly }: DateOperandProps) => {
  return isAbsoluteDate ? (
    <DefinitionDatePicker
      name={`${base}.EventOccurred.operation.operandDate`}
      readOnly={readOnly}
    />
  ) : (
    <TimeframeInput name={`${base}.EventOccurred.operation.operand`} readOnly={readOnly} />
  );
};

interface EventOccurredProps {
  name: string;
  base: string;
  readOnly?: boolean;
}

export const EventOccurred = ({ name, base, readOnly }: EventOccurredProps) => {
  const { values, setFieldValue } = useFormikContext<DefinitionFormikValues>();

  const dateOperationType = get(values, name);
  const isInfiniteDate = dateOperationType && dateOperationType.includes('infinite');
  const isAbsoluteDate = dateOperationType && dateOperationType.includes('absolute');

  return (
    <>
      <Select<DefaultItemProps, DefinitionFormikValues>
        name={name}
        options={eventOccurredOptions}
        readOnly={readOnly}
        placeholder="Choose operator"
        InputWrapper={SelectInputWrapper}
        data-cy="segment-definition-selector"
        values={values}
        setFieldValue={setFieldValue}
        validateOnSelectWithErrors
      />
      {!isInfiniteDate && dateOperationType && (
        <DateOperand isAbsoluteDate={isAbsoluteDate} base={base} readOnly={readOnly} />
      )}
    </>
  );
};
